import { T } from "./translation-keys";
import { GroupTypesEnum } from "../enums";

export const GroupTypeNames = {
  [GroupTypesEnum.BusinessUnit]: T.BUSINESS,
  [GroupTypesEnum.Betshop]: T.BETSHOP,
  [GroupTypesEnum.Manager]: T.MANAGER,
  [GroupTypesEnum.Cashier]: T.CASHIER,
  [GroupTypesEnum.Partner]: T.PARTNER,
  [GroupTypesEnum.Game]: T.GAME,
};

export const GroupTypeParamNames = {
  [GroupTypesEnum.BusinessUnit]: 'businessUnitIds',
  [GroupTypesEnum.Betshop]: 'betshopIds',
  [GroupTypesEnum.Manager]: 'managerIds',
  [GroupTypesEnum.Cashier]: 'cashierIds',
  [GroupTypesEnum.Partner]: 'partnerIds',
  [GroupTypesEnum.Game]: 'gameIds',
};